<template>
    <div class="main_holder">
        <div class="content_holder">
            <div class="content sections_dashboard">
                <h2>Prikaz podatkov za program</h2>

                <!-- prikazi samo tistim, ki se kasneje dodajo podatki - FE, EF, FRI, FU, FKKT -->
                <!-- && programs_data_by_user[selected_program_id] && ([10, 16, 24,26, 25].includes(programs_data_by_user[selected_program_id].faculty_id)) -->
                <!-- prikazi samo tistim, ki so doktorati -->
                <!-- || isDoctorate -->
                <div v-if="isActiveYear && (programs_data_by_user[selected_program_id] && ([10, 16, 24, 26, 25].includes(programs_data_by_user[selected_program_id].faculty_id)))"
                    class="questionnaire_warning warning">
                    <p>Podatki na podlagi rezultatov študentskih anket so v pripravi.
                        V grafih so zaenkrat vidni podatki do študijskega leta 2024/25, 
                        podatki za študijsko leto 2025/26 bodo vključeni naknadno.
                    </p>
                </div>

                <div class="dashboard_tools">
                    <div class="dashboard_tools_top">
                        <div class="toolbar_select">
                            Program:
                            <select v-model="selected_program_id">
                                <option v-for="program in sortedPrograms" :value="program.id" :key="program.id">
                                    {{ program.name }} ({{ program.ul_program_id }})
                                </option>
                            </select>
                        </div>
                        <div class="toolbar_select">
                            Sklop:
                            <select v-model="selected_set">
                                <option v-for="set in sortedSets" v-bind:value="set.code" v-bind:key="set.code"
                                    :selected="(selected_set == set.code ? true : null)">
                                    {{ set.name }}
                                </option>
                            </select>
                        </div>

                        <div class="dashboard_tools_stamp_filter" v-show="!isDoctorate && selected_set !== 'tables'">
                            Dodaj povprečje programov:
                            <div class="basic equal_margin"
                                :class="{ deadline_status_empty: !stamp_filter_active.averages.all, deadline_status: stamp_filter_active.averages.all }"
                                @click="stamp_filter_active.averages.all = !stamp_filter_active.averages.all;">vseh
                                članic</div>
                            <div class="basic equal_margin"
                                :class="{ deadline_status_empty: !stamp_filter_active.averages.faculty, deadline_status: stamp_filter_active.averages.faculty }"
                                @click="stamp_filter_active.averages.faculty = !stamp_filter_active.averages.faculty;">
                                {{ getFacultyAcronym }}</div>
                            <div class="basic equal_margin"
                                :class="{ deadline_status_empty: !stamp_filter_active.averages.level, deadline_status: stamp_filter_active.averages.level }"
                                @click="stamp_filter_active.averages.level = !stamp_filter_active.averages.level;">vseh
                                članic iste stopnje</div>
                        </div>
                    </div>
                </div>

                <div class="evalvation_dashboard_graphs" v-if="programs_data_by_user[selected_program_id] &&
                    evalvation_dashboard_values[programs_data_by_user[selected_program_id].ul_program_id]">
                    <div class="tables_container"
                        v-if="selected_set == 'tables' && evalvation_dashboard_values[programs_data_by_user[selected_program_id].ul_program_id][selected_set]">
                        <template v-for="component in sortedTables" :key="component.id">
                            <template
                                v-if="evalvation_dashboard_values[programs_data_by_user[selected_program_id].ul_program_id]?.[selected_set]?.[component.code]">
                                <TableDataset class="table_container"
                                    :dataset_data="evalvation_dashboard_values[programs_data_by_user[selected_program_id].ul_program_id][selected_set][component.code]"
                                    :description="component.description" :dataset_name="component.code" />
                            </template>
                        </template>
                    </div>
                    <div class="graphs_container"
                        v-else-if="evalvation_dashboard_values[programs_data_by_user[selected_program_id].ul_program_id][selected_set]">
                        <div v-for="group in groupedComponents" :key="group.subset_name || 'default'"
                            class="subset_group">
                            <h3 v-if="group.showTitle && group.subset_name" class="subset_title">{{ group.subset_name }}
                            </h3>
                            <div class="subset_graphs">
                                <GraphDataset v-for="component in group.components" :key="component.id"
                                    :dataset="generate_line_graph_data(component)"
                                    :description="get_description(component)" :display_mode_bar="null" />
                            </div>
                        </div>
                    </div>
                    <div v-else class="dashboard_no_data">Za izbran sklop ni podatkov</div>
                </div>
                <div v-else class="dashboard_no_data">Za izbran program ni podatkov</div>

                <!-- Active year warning -->
                <div v-show="programs_data_by_user[selected_program_id] &&
                    evalvation_dashboard_values[programs_data_by_user[selected_program_id].ul_program_id] &&
                    evalvation_dashboard_values[programs_data_by_user[selected_program_id].ul_program_id][selected_set] &&
                    isDoctorate">
                    <p><i>* V grafih so prikazani podatki za letnike, za katere so bili zbrani podatki (glede na legendo).
                            Če podatki za
                            določen letnik manjkajo, kljub temu da je naveden v legendi, pomeni, da za ta letnik ni bilo
                            dovolj zbranih
                            podatkov za objavo (manj kot 4).</i></p>
                </div>

                <!-- Active year warning -->
                <div v-show="programs_data_by_user[selected_program_id] &&
                    evalvation_dashboard_values[programs_data_by_user[selected_program_id].ul_program_id] &&
                    evalvation_dashboard_values[programs_data_by_user[selected_program_id].ul_program_id][selected_set] &&
                    selected_set == 'practice'">
                    <p><i>* Od študijskega leta 2025/2026 dalje numerus (N) pri praktičnem usposabljanju označuje le število odgovorov, 
                        ki se nanašajo na prakso, in ne več skupnega števila odgovorov v anketi po zaključnem preverjanju znanja. 
                        Sprememba v prikazanem numerusu ne vpliva na primerljivost podatkov s predhodnimi študijskimi leti.</i></p>
                </div>

            </div>
        </div>
    </div>
</template>


<script>
import { mapActions } from "vuex";
import GraphDataset from './datasets/DashboardGraphData.vue';
import TableDataset from './datasets/DashboardTableData.vue';

export default {
    name: "EvalvationDashboard",
    components: {
        GraphDataset,
        TableDataset,
    },
    data: function () {
        return {
            selected_program_id: 0,
            selected_set: '',
            selected_component: '',
            stamp_filter_active: {
                averages: {
                    all: false,
                    faculty: false,
                    level: false
                }
            },
            overflow_percent: 0.07,
        };
    },
    computed: {
        year() {
            return this.$store.getters.year;
        },

        // Check if we are in active year
        isActiveYear() {
            return this.$store.getters.is_active_year;
        },

        // Get loged user faculty id
        getFacultyId() {
            return this.$store.getters.getFaculty.id;
        },

        // Get loged user faculty acronym
        getFacultyAcronym() {
            return this.$store.getters.getFaculty.acronym;
        },

        // Get loged user type
        getUserType() {
            return this.$store.state.user.type;
        },

        programs_data_by_user() {
            return this.$store.getters.evalvation_programs_user ? this.$store.getters.evalvation_programs_user : {};
        },

        evalvation_dashboard_sets() {
            return this.$store.getters.evalvation_dashboard_sets ? this.$store.getters.evalvation_dashboard_sets : {};
        },

        evalvation_dashboard_components() {
            return this.$store.getters.evalvation_dashboard_components ? this.$store.getters.evalvation_dashboard_components : {};
        },

        evalvation_dashboard_values() {
            return this.$store.getters.evalvation_dashboard_values ? this.$store.getters.evalvation_dashboard_values : {};
        },

        evalvation_dashboard_averages() {
            return this.$store.getters.evalvation_dashboard_averages ? this.$store.getters.evalvation_dashboard_averages : {};
        },

        // Sortiranje programov
        sortedPrograms: function () {
            let col = Intl.Collator("sl");
            let res = Object.values(this.programs_data_by_user).sort((a, b) => {
                return (col.compare(a.name, b.name) < 0) ? -1 : 1;
            });

            //set default selected program
            if (res[0])
                this.selected_program_id = res[0].id;

            return res;
        },

        // Sortiranje sklopov
        sortedSets: function () {
            // Get the year start from the year - because we don't want to show old doctorate sets before 2025
            const yearStart = parseInt(this.year.substring(0, 4), 10);

            // First filter the array based on the condition
            let filteredRes = Object.values(this.evalvation_dashboard_sets).filter(a => {

                // If the set is doctorate and the year start is 2025 or more, don't show it
                if (a.code === 'doctorate' && yearStart >= 2025) {
                    return false;
                }

                if (!this.isDoctorate && a.stopnja != 3) {
                    return true; // Include element
                } else if (this.isDoctorate && (a.stopnja == 3 || a.stopnja == 0)) {
                    return true; // Include element
                }
                return false; // Exclude element
            });

            // Then sort the filtered array
            /* let res = filteredRes.sort((a, b) => {
                return col.compare(a.name, b.name) < 0 ? -1 : 1;
            }); */

            // what order should we show the tables
            let orderedKeys = ['tables', 'before1', 'after1', 'practice', 'general_aspects', 'infrastructure', 'zadovoljstvo', 'pomoc_mentorja', 'pomoc_somentorja', 'mednarodno_udejstvovanje', 'pomoc_referat', 'doctorate'];

            // sort the tables based on the order
            let res = filteredRes.sort((a, b) => {
                let indexA = orderedKeys.indexOf(a.code);
                let indexB = orderedKeys.indexOf(b.code);

                // Handle cases where index is -1 by moving those items to the end
                if (indexA === -1) indexA = orderedKeys.length;
                if (indexB === -1) indexB = orderedKeys.length;

                return indexA - indexB;
            });

            // Set default selected set
            if (res[0]) {
                this.selected_set = res[0].code;
            }

            return res;
        },

        isDoctorate: function () {
            let stopnja = (this.programs_data_by_user[this.selected_program_id] &&
                this.programs_data_by_user[this.selected_program_id].stopnja) ?
                this.programs_data_by_user[this.selected_program_id].stopnja : '';
            return stopnja === 'tretja stopnja';
        },

        // Components of the selected set, grouped by subset_name.
        // A single subset_name is shown without a title.
        groupedComponents: function () {
            let set = Object.values(this.evalvation_dashboard_sets)
                .find(s => s.code === this.selected_set);
            if (!set)
                return [];

            let program = this.programs_data_by_user[this.selected_program_id];
            let values = program
                ? this.evalvation_dashboard_values[program.ul_program_id]?.[this.selected_set]
                : null;

            let components = Object.values(this.evalvation_dashboard_components)
                .filter(c => String(c.set_id) === String(set.id))
                .filter(c => values && values[c.code])
                .sort((a, b) => a.order_number - b.order_number);

            let subsetNames = [...new Set(components.map(c => c.subset_name))];
            let showTitles = subsetNames.length > 1;

            let groups = [];
            for (let component of components) {
                let group = groups.find(g => g.subset_name === component.subset_name);
                if (!group) {
                    group = {
                        subset_name: component.subset_name,
                        showTitle: showTitles,
                        components: [],
                    };
                    groups.push(group);
                }
                group.components.push(component);
            }

            if (groups[0] && groups[0].components[0])
                this.selected_component = groups[0].components[0].code;

            return groups;
        },

        sortedTables: function () {
            let res = Object.values(this.evalvation_dashboard_components);

            // what order should we show the tables
            let orderedKeys = ['vpis', 'prehodnost', 'tuji_vpisani', 'diplomanti'];

            // filter in only the tables based on the order
            res = Object.values(this.evalvation_dashboard_components).filter(a => {
                return orderedKeys.includes(a.code);
            });

            // sort the tables based on the order
            res.sort((a, b) => {
                return orderedKeys.indexOf(a.code) - orderedKeys.indexOf(b.code);
            });


            //set default selected component
            if (res[0])
                this.selected_component = res[0].code;

            return res;
        },
    },
    methods: {
        ...mapActions(["getEvalDashboard",
            'getProgramsListForUser',
            'getProgramsListForFaculty',]),

        get_description(component) {
            let description = component.description;

            if(component.code == 'preverjanje_znanja_skladni') {
                description += '<br><i>* Postavka je bila v anketo vključena v študijskem letu 2025/2026.</i>';
            }

            return description;
        },

        // get array of range of 5 years prior to this year
        year_range_study() {
            let year_from = this.year.substring(this.year.lastIndexOf('/') + 1) - 5;

            let range = [];
            for (let i = year_from; i <= year_from + 4; i++) {
                let year = i + '/' + (i + 1);
                range.push(year);
            }
            return range;
        },

        // get array of range of 5 years prior to this year
        year_range() {
            let year_from = this.year.substring(this.year.lastIndexOf('/') + 1) - 5;

            let range = [];
            for (let i = year_from; i <= year_from + 4; i++) {
                let year = i;
                range.push(year);
            }
            return range;
        },

        generate_line_graph_data(component) {
            // Local variables for each graph
            let fixed_range = true;
            let min_value = 0;
            let max_value = 0;

            // Determine if it is a doctorate program
            let data = this.isDoctorate
                ? this.generate_line_graph_data_dr(component)
                : this.generate_line_graph_data_normal(component);

            // Return both the data and the layout parameters
            return {
                data: this.isDoctorate ? data.data : data,
                fixed_range: this.isDoctorate ? data.fixed_range : fixed_range,
                min_value: this.isDoctorate ? data.min_value : min_value,
                max_value: this.isDoctorate ? data.max_value : max_value
            };
        },

        generate_line_graph_data_dr(component) {
            let data = [];
            let program_values = this.evalvation_dashboard_values[this.programs_data_by_user[this.selected_program_id].ul_program_id];

            let fixed_range = true;
            let min_value = 0;
            let max_value = 0;
            const letnik_colors = { 'I. letnik': "#d62728", 'II. letnik': "#2ca02c", 'III. letnik': "#ff7f0e", 'IV. letnik': "#1f77b4" };

            // A set to collect all unique years across all letniks
            let allYearsSet = new Set();
            //add all years to the set
            for (let year of this.year_range()) {
                allYearsSet.add(year);
            }

            let letnikMap = {};
            let letnikMapN = {};

            if (program_values) {
                // Iterate through all values
                for (let value_obj of program_values[this.selected_set][component.code]) {
                    let letnik = value_obj.letnik;
                    let year = value_obj.year;

                    // Add the year to the set of all unique years
                    //allYearsSet.add(year);

                    // Initialize an object for the letnik if it doesn't exist
                    if (!letnikMap[letnik]) {
                        letnikMap[letnik] = {};
                        letnikMapN[letnik] = {};
                    }

                    // Add the value for the corresponding letnik and year
                    letnikMap[letnik][year] = parseInt(value_obj.value) > 0 ? parseFloat(value_obj.value) : null;
                    letnikMapN[letnik][year] = parseInt(value_obj.N_anket_sum);
                }

                // Convert the set of all years to a sorted array (ascending order)
                let allYears = Array.from(allYearsSet).sort((a, b) => a - b);

                // Sort letnik in descending order (assuming Roman numerals or similar)
                let sortedLetniks = Object.keys(letnikMap).sort((a, b) => b.localeCompare(a, undefined, { numeric: true }));

                // Generate Plotly data for each letnik in descending order
                for (let letnik of sortedLetniks) {
                    let x = [];
                    let y = [];
                    let text = []; // Array to store hover text

                    // Align each letnik's data to the full range of years
                    for (let year of allYears) {
                        // Always push the year to the x-axis
                        x.push(year + '/' + (parseInt(year) + 1));

                        // Add the corresponding value for the year, or null if not available
                        let letnik_value = letnikMap[letnik][year] || null;
                        // Round the value to one decimal place
                        letnik_value = letnik_value !== null ? (Math.round(parseFloat(letnik_value) * 10) / 10) : null;
                        y.push(letnik_value);

                        // Dynamically get additional data (e.g., N value) for this point
                        let additional_text = (letnikMapN[letnik][year] != 0 ? ' (N=' + letnikMapN[letnik][year] + ')' : '');

                        // Add hover text including the Y value and additional data
                        text.push(
                            letnik_value !== null
                                ? letnik_value + additional_text
                                : null
                        );

                        if (letnik_value !== null && parseInt(letnik_value) > 0) {
                            // Calculate min_value and max_value
                            if ((letnik_value - (letnik_value * this.overflow_percent)) < min_value || min_value === 0) {
                                min_value = letnik_value - (letnik_value * this.overflow_percent);
                            }

                            if (letnik_value > 5) {
                                fixed_range = false;

                                // Calculate max value
                                if ((letnik_value + (letnik_value * this.overflow_percent)) > max_value) {
                                    max_value = letnik_value + (letnik_value * this.overflow_percent);
                                }
                            }
                        }
                    }

                    // Add the series for the current letnik
                    data.push({
                        x: x,
                        y: y,
                        type: 'scatter',
                        text: text, // Add the text for hover
                        line: {
                            color: letnik_colors[letnik] // Use the color from the map
                        },
                        hovertemplate: '%{text}<extra></extra>', // Use text in hover template
                        name: letnik // Label the line with the letnik
                    });
                }
            }

            return {
                data: data,
                fixed_range: fixed_range,
                min_value: min_value,
                max_value: max_value
            };
        },

        generate_line_graph_data_normal(component) {
            let data = [];
            let program_values = this.evalvation_dashboard_values[this.programs_data_by_user[this.selected_program_id].ul_program_id];
            //array of years that will be ibind of all lines to program values
            let x_year = this.year_range();
            let text = [null, null, null, null, null]; // Array to store hover text

            //array of years that will be bind of all lines to program values
            let x = this.year_range_study();

            if (program_values) {
                let yp = [null, null, null, null, null];

                for (let value_obj of program_values[this.selected_set][component.code]) {
                    if (parseInt(value_obj.value) > 0) {
                        //get index of year in x_year array
                        let index = x_year.indexOf(value_obj.year);
                        let graph_value = (Math.round(parseFloat(value_obj.value) * 10) / 10);
                        yp[index] = graph_value;

                        // Dynamically get additional data (e.g., N value) for this point
                        let additional_text = (value_obj.N_anket_sum != 0 ? ' (N=' + value_obj.N_anket_sum + ')' : '');

                        // Add hover text including the Y value and additional data
                        text[index] = graph_value + additional_text;
                    }
                }

                data.push({
                    x: x,
                    y: yp,
                    text: text, // Add the text for hover
                    hovertemplate: '%{text}<extra></extra>', // Use text in hover template
                    //name: this.truncate(this.organizations[this.org_type][org_code].name),
                    //visible: this.org_type == 0 ? true : 'legendonly',
                    type: 'scatter',
                    name: 'program'
                });
            }

            if (this.stamp_filter_active.averages.all) {
                let ya = [null, null, null, null, null];

                let program_values = this.evalvation_dashboard_averages.all;
                for (let year of x_year) {
                    let value_obj = program_values[this.selected_set][component.code].find(obj => obj.year == year);

                    if (value_obj && parseInt(value_obj.value) > 0) {
                        //get index of year in x_year array
                        let index = x_year.indexOf(value_obj.year);
                        ya[index] = (parseFloat(value_obj.value));
                    }
                }

                data.push({
                    x: x,
                    y: ya,
                    type: 'scatter',
                    name: 'povprečje UL'
                });
            }

            if (this.stamp_filter_active.averages.faculty) {
                let yf = [null, null, null, null, null];

                let program_values = this.evalvation_dashboard_averages.faculty;
                for (let year of x_year) {
                    let value_obj = program_values[this.selected_set][component.code].find(obj => obj.year == year);

                    if (value_obj && parseInt(value_obj.value) > 0) {
                        let index = x_year.indexOf(value_obj.year);
                        yf[index] = (parseFloat(value_obj.value));
                    }
                }

                data.push({
                    x: x,
                    y: yf,
                    type: 'scatter',
                    name: 'povprečje ' + this.getFacultyAcronym
                });
            }

            if (this.stamp_filter_active.averages.level) {
                let yl = [null, null, null, null, null];

                let program_values = this.evalvation_dashboard_averages.level[this.programs_data_by_user[this.selected_program_id].stopnja];
                for (let year of x_year) {
                    let value_obj = program_values[this.selected_set][component.code].find(obj => obj.year == year);

                    if (value_obj && parseInt(value_obj.value) > 0) {
                        let index = x_year.indexOf(value_obj.year);
                        yl[index] = (parseFloat(value_obj.value));
                    }
                }

                data.push({
                    x: x,
                    y: yl,
                    type: 'scatter',
                    name: 'povprečje stopnje'
                });
            }

            return data;
        },

        isProgramDoctorate: function (selected_program_id) {
            let stopnja = (this.programs_data_by_user[selected_program_id] &&
                this.programs_data_by_user[selected_program_id].stopnja) ?
                this.programs_data_by_user[selected_program_id].stopnja : '';
            return stopnja === 'tretja stopnja';
        },

        refresh_dashboard() {
            if (this.getUserType > 0)
                this.getProgramsListForFaculty();
            else
                this.getProgramsListForUser();

            this.getEvalDashboard();
        }
    },

    watch: {
        year: {
            handler(newVal, oldVal) {
                this.refresh_dashboard();
            },
            deep: true // required only if activeFaculty is an array and you want to track mutations
        },
        getFacultyId: {
            handler(newVal, oldVal) {
                this.refresh_dashboard();
            },
            deep: true // required only if activeFaculty is an array and you want to track mutations
        },
        selected_program_id: {
            handler(newVal, oldVal) {
                //if stopnja is changed, reset the averages and set the set to tables
                if (this.isProgramDoctorate(oldVal) !== this.isProgramDoctorate(newVal)) {
                    this.stamp_filter_active.averages.level = false;
                    this.stamp_filter_active.averages.faculty = false;
                    this.stamp_filter_active.averages.all = false;
                    this.selected_set = 'tables';
                }
            },
            deep: true // required only if activeFaculty is an array and you want to track mutations
        }
    },

    created() {
        this.refresh_dashboard();
    }
};
</script>


<style lang="scss" scoped></style>
